module.exports = __webpack_public_path__ + "./assets/wahoo-1bfe66.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wahoo.bmp
// module id = 22
// module chunks = 0